<template>
<div class="chapter">
<div class="inner_page">
<a id="page_v"></a>
<p class="dedit">This book is dedicated:</p>
<p class="dedi">To my friends Spyros Bakas, without the help of whom – and that of the Koryvantes gang – this trilogy would have never materialized, and to George A. Galatsanos, who assisted me in every possible way for years.</p>
<a id="page_vi"></a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_Dedi.vue?64ff7084